// extracted by mini-css-extract-plugin
module.exports = {"m-1600":"seo-pagination_m-1600__Mjc8B","pagination":"seo-pagination_pagination__VyFuW","active":"seo-pagination_active__QulN_","disabled":"seo-pagination_disabled__DdGW1"};